import styles from './create-account-card.module.sass';
import TextInput from 'componets/text-input';
import Button from 'componets/button';
import analytics from 'service/analytics';

export const CreateAccountForm = ({
  phoneNumber,
  phoneNumberError,
  onClose,
  onPhoneNumberChange,
  onFormSubmit,
  isLoading,
}) => {
  const handleSave = () => {
    analytics.driverPageCreateDriverAccountSaveClick();
    onFormSubmit({ mobile: phoneNumber });
  };

  return (
    <div className={styles['create-account-form']}>
      <h4 className={styles['title']}>新增駕駛帳號</h4>
      <div className={styles['input-section']}>
        <label>駕駛帳號</label>
        <TextInput
          maxLength={10}
          placeholder="輸入駕駛的手機號碼"
          newText={phoneNumber}
          onKeyPress={handleSave}
          onTextChange={onPhoneNumberChange}
          isInvalid={!!phoneNumberError}
        />
        {phoneNumberError && <p className={styles['error-message']}>{phoneNumberError}</p>}
      </div>
      <div className={styles['button-container']}>
        <Button
          variant="text"
          onClick={() => {
            analytics.driverPageCreateDriverAccountCancelClick();
            onClose();
          }}
        >
          取消
        </Button>
        <Button onClick={handleSave} loading={isLoading}>
          儲存
        </Button>
      </div>
    </div>
  );
};
